import React from 'react'
import PropTypes from 'prop-types'
import { renderReactComponents } from '../Utilities/RichTextRenderer'

function RichTextBlockV3({ data }) {
  const { paragraph } = data
  let textRendered

  const textData = {
    richText: paragraph,
    onEvent: undefined
  }

  if (paragraph) {
    textRendered = renderReactComponents(textData)
  }

  return <div className="rich-text-section-container-text container__inner">{textRendered}</div>
}

RichTextBlockV3.propTypes = {
  data: PropTypes.object.isRequired
}

export { query as data } from './richTextQuery'

export default RichTextBlockV3
